import React from 'react';

import { TFormContentComponentProps } from '@/shared/components/ui/form/form-content.types';
import { FormContentRoot } from '@/shared/components/ui/form/form.styled';
import { useScrollFade } from '@/shared/components/ui/scroll-fade/use-scroll-fade/use-scroll-fade';

export const FormContent: React.FC<TFormContentComponentProps> = ({
  $overflowVisible,
  children,
  ...rest
}) => {
  const { ref, fadeStart, fadeEnd } = useScrollFade({
    enabled: !$overflowVisible,
  });

  return (
    <FormContentRoot
      ref={ref}
      $overflowVisible={$overflowVisible}
      $fadeStart={fadeStart}
      $fadeEnd={fadeEnd}
      {...rest}
    >
      {children}
    </FormContentRoot>
  );
};
